<template>
  <ul class="tabs">
<!--    <li><a href="#" :class="allActive" @click="setActiveItems(all)">{{$t('filters.all')}}</a></li>-->
    <li>
      <a href="#" :class="currentActive" @click="setActiveItems(current)">{{$t('filters.next')}}</a></li>
    <li><a href="#" :class="pastActive" @click="setActiveItems(past)">{{$t('filters.past')}}</a></li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CurrentPastEventsFilter',
  emits: ['onChangeFilter'],
  data: () => {
    return {
      all: 'all',
      current: 'current',
      past: 'past',
      itemsToShow: ''
    }
  },
  computed: {
    allActive () {
      return this.itemsToShow === this.all ? 'bt active' : 'bt btG'
    },
    currentActive () {
      return this.itemsToShow === this.current ? 'bt active' : 'bt btG'
    },
    pastActive () {
      return this.itemsToShow === this.past ? 'bt active' : 'bt btG'
    },
  },
  mounted () {
    this.itemsToShow = this.current
  },
  methods: {
    setActiveItems (userPreference: string) {
      this.itemsToShow = userPreference
      this.$emit('onChangeFilter', userPreference)
    }
  }
})
</script>
